module.exports = __webpack_public_path__ + "static/img/senceIcon2.1e83a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/senceIcon2.png
// module id = z1jA
// module chunks = 1